import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import colors from '../../config/colors';

/**
 * Base Card component with modern styling
 * Replaces the old bordered box layout
 */
function Card({ children, style }) {
    return (
        <View style={[styles.card, style]}>
            {children}
        </View>
    );
}

const styles = StyleSheet.create({
    card: {
        backgroundColor: colors.white,
        borderRadius: 12,
        padding: 16,
        marginVertical: 8,
        marginHorizontal: 4,
        ...Platform.select({
            ios: {
                shadowColor: colors.black,
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.1,
                shadowRadius: 4,
            },
            android: {
                elevation: 3,
            },
            web: {
                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
            },
            default: {
                borderWidth: 1,
                borderColor: '#e0e0e0',
            }
        }),
    },
});

export default Card;
